import { call, put, takeEvery } from "redux-saga/effects";
import { BUSINESS } from "./actionTypes";
import { getBusiness, getListaBusiness, saveBusiness } from "./actions";
import moment from "moment";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { BUSINESS_URL } from "../../helpers/url_api_helper";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarBusiness({ payload }) {
  const filterBusiness = payload;
  try {
    emptyStringToNull(filterBusiness);
    const res = yield call(BUSINESS_URL.getBusinesses, filterBusiness);
    yield put(getListaBusiness.success(res));
  } catch (error) {
    yield put(getListaBusiness.fail(normalizeApiError(error, "Something went wrong retrieving the system's business, please try again later")));
  }
}

function* obterBusiness({ payload }) {
  const { businessId } = payload;
  try {
    const res = yield call(BUSINESS_URL.getBusiness, businessId);
    res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString();
    res.updateDate =
      res.updateDate !== null
        ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString()
        : "";
    yield put(getBusiness.success(res));
  } catch (error) {
    yield put(getBusiness.fail(normalizeApiError(error, "Something went wrong retrieving the system's business, please try again later")));
  }
}

function* salvarBusiness({ payload }) {
  const { body, type } = payload;
  try {
    if (type === "POST") {
      yield call(BUSINESS_URL.postBusiness, body);
      yield put(saveBusiness.success(true));
    } else {
      yield call(BUSINESS_URL.putBusiness, body);
      yield put(saveBusiness.success(true));
    }
  } catch (error) {
    yield put(saveBusiness.fail(normalizeApiError(error, "Something went wrong retrieving the system's business, please try again later")));
  }
}

function* BusinessSaga() {
  yield takeEvery(BUSINESS.GET_LISTA_BUSINESS.REQUEST, listarBusiness);
  yield takeEvery(BUSINESS.GET_BUSINESS.REQUEST, obterBusiness);
  yield takeEvery(BUSINESS.SAVE_BUSINESS.REQUEST, salvarBusiness);
}

export default BusinessSaga;
